import { h, Component } from 'preact';
import GemComponentsView from './gemComponentsView/GemComponentsView';
import s from './scss/gemView.scss';
import cn from 'classnames';

export default class GemView extends Component {
  constructor(props) {
    super(props);
    this.getVPwidth();

    window.addEventListener('resize', () => {
      this.getVPwidth();
    });
  }

  getVPwidth = () => {
    this.state = {
      vw: Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
      ),
      vh: Math.max(
        document.documentElement.clientHeight,
        window.innerHeight || 0
      )
    };
  };

  render() {
    let inlineStyle;

    // set ratio
    if (this.state.vw > 1024) {
      // 3:1
      inlineStyle = {
        height: (this.state.vw / 3)
      };
    } else {
      // 2:1
      inlineStyle = {
        height: (this.state.vw / 2)
    };
  }
    return (
      <div className={cn(s.wrapper)} style={inlineStyle}>

        <GemComponentsView
          className={s.componentsView}
          vh={this.state.vh}
          vw={this.state.vw}
        />
      </div>
    );
  }
}
